/* threeLOPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./threeLOPrompt.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { lazy, useEffect } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import { Stack } from '@atlaskit/primitives';
import { Box } from '@atlaskit/primitives/compiled';
import SectionMessage from '@atlaskit/section-message';
import Button from '@atlaskit/button/new';
import { fg } from '@atlaskit/platform-feature-flags';
import { useAuth } from './useAuth';
import { AkButton } from '../UIKit1/button/Button';
var LegacySectionMessage = /*#__PURE__*/lazy(function () {
  return import('@atlaskit/section-message');
});
var styles = {
  box: "_1h6dtmh3 _1dqonqa1 _189ejfq9"
};
var ThreeLOPrompt = function ThreeLOPrompt(props) {
  var _useAuth = useAuth(props),
    loading = _useAuth.loading,
    startAuth = _useAuth.startAuth,
    promptMessage = _useAuth.promptMessage,
    buttonText = _useAuth.buttonText;
  var authUrl = props.authUrl,
    onInitialization = props.onInitialization;
  useEffect(function () {
    if (onInitialization) {
      onInitialization();
    }
  }, [onInitialization]);
  if (!authUrl || authUrl === '') {
    if (fg('fix-react-18-concurrent-upgrade-infinite-rendering')) {
      return /*#__PURE__*/React.createElement(SectionMessage, {
        appearance: "error"
      }, /*#__PURE__*/React.createElement(FormattedMessage, messages.noAuthURLErrorMessage));
    }
    return /*#__PURE__*/React.createElement(LegacySectionMessage, {
      appearance: "error"
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.noAuthURLErrorMessage));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    padding: "space.250",
    xcss: styles.box
  }, /*#__PURE__*/React.createElement(Stack, {
    alignInline: "start",
    space: "space.250",
    grow: "hug",
    testId: "three-lo-prompt"
  }, /*#__PURE__*/React.createElement(Box, null, promptMessage), fg('fix-react-18-concurrent-upgrade-infinite-rendering') ? /*#__PURE__*/React.createElement(Button, {
    onClick: startAuth,
    isLoading: loading
  }, buttonText) : /*#__PURE__*/React.createElement(AkButton, {
    onClick: startAuth,
    isLoading: loading
  }, buttonText))));
};
export default ThreeLOPrompt;
export var ThreeLOPromptRenderFn = function ThreeLOPromptRenderFn(_ref) {
  var forgeDoc = _ref.forgeDoc,
    dispatch = _ref.dispatch;
  var _ref2 = forgeDoc.props,
    message = _ref2.message,
    authUrl = _ref2.authUrl,
    promptText = _ref2.promptText;
  return /*#__PURE__*/React.createElement(ThreeLOPrompt, {
    message: message,
    authUrl: authUrl,
    promptText: promptText,
    onSuccess: function onSuccess() {
      return dispatch({
        type: 'render',
        extensionData: {}
      });
    }
  });
};
export var makeThreeLOPrompt = function makeThreeLOPrompt(_ref3) {
  var appName = _ref3.appName,
    _onSuccess = _ref3.onSuccess;
  return function threeLOPrompt(_ref4) {
    var props = _ref4.forgeDoc.props,
      dispatch = _ref4.dispatch;
    var _ref5 = props,
      message = _ref5.message,
      authUrl = _ref5.authUrl,
      promptText = _ref5.promptText;
    return /*#__PURE__*/React.createElement(ThreeLOPrompt, {
      message: message,
      authUrl: authUrl,
      promptText: promptText,
      appName: appName,
      onSuccess: function onSuccess() {
        if (_onSuccess) {
          _onSuccess();
        }
        return dispatch({
          type: 'render',
          extensionData: {}
        });
      }
    });
  };
};
export var makeThreeLOPromptForCustomUI = function makeThreeLOPromptForCustomUI(_ref6) {
  var appName = _ref6.appName,
    _onSuccess2 = _ref6.onSuccess,
    message = _ref6.message,
    onInitialization = _ref6.onInitialization;
  return function threeLOPrompt(props) {
    var authUrl = props.authUrl,
      promptText = props.promptText,
      onSuccessFromIframeComponent = props.onSuccess;
    return /*#__PURE__*/React.createElement(ThreeLOPrompt, {
      message: message,
      authUrl: authUrl,
      promptText: promptText,
      appName: appName,
      onSuccess: function onSuccess() {
        if (_onSuccess2) {
          _onSuccess2();
        }
        return Promise.resolve(onSuccessFromIframeComponent);
      },
      onInitialization: onInitialization
    });
  };
};
var messages = defineMessages({
  noAuthURLErrorMessage: {
    id: 'confluence.threeLOPrompt.no.authURL.error-message',
    defaultMessage: 'Consent URL not found. Please refresh the page and try again.',
    description: 'This text is displayed when the URL that gives an app certain permissions is not present.'
  }
});